import { capitalize } from "web/services/inflector"
import { DAYS_OF_WEEK, DAYS_OF_MONTH, FREQUENCY_MONTHLY } from "../constants"

function buildScheduledExportMeta({ daysOfWeek, daysOfMonth, frequency }) {
  if (frequency === FREQUENCY_MONTHLY.toLowerCase()) {
    const day = DAYS_OF_MONTH.find((d) => d.value === daysOfMonth[0])
    return `${capitalize(frequency)} on ${day.label}`
  } else {
    const day = DAYS_OF_WEEK.find((d) => d.value === daysOfWeek[0])
    return `${capitalize(frequency)} on ${day.label}`
  }
}

export default function ScheduleMenuItem({ scheduledExport, editUrl }) {
  const { days_of_week, days_of_month, frequency } = scheduledExport
  const openSchedule = () => window.Turbo.visit(editUrl, { frame: "modal" })

  return (
    <div
      className="cursor-pointer rounded p-2 hover:bg-primary-10"
      onClick={openSchedule}
    >
      <div className="font-bold capitalize">{scheduledExport.name}</div>
      <div className="text-sm leading-3 text-gray-500">
        {buildScheduledExportMeta({
          daysOfWeek: days_of_week,
          daysOfMonth: days_of_month,
          frequency,
        })}
      </div>
    </div>
  )
}
